import React, {
  //
  useState,
  useContext,
} from "react";
import {
  //
  logs,
  BearDiv,
  bearlog,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import useKeypress from "react-use-keypress";
import {
  bassKey,
  keyArray,
  letterConst,
  numberConst,
} from "../consts/keyConst";
import { useKey } from "rooks";

export function KeyComp() {
  // 1const
  const {
    //
    isnSound,
    setisnSound,
    reffo,
    playChord,
    playKey,
    shiftpic,
    playMain,
    picho,
  } = useContext(MainContext);

  const keyParams = {
    eventTypes: ["keydown", "keyup"],
  };
  useKey(numberConst, (aaa) => keyo(aaa, afafas), keyParams);
  useKey(letterConst, (aaa) => keyo(aaa, sdfg), keyParams);
  // useKey(bassKey, (aaa) => keyo(aaa, asdflwe), keyParams);

  useKey(["ArrowLeft", "ArrowRight"], (aaa) => keyo(aaa, acasd));

  function keyo(aaa, func) {
    bearlog.lug("___ aaa, func ___", aaa);

    func(aaa);
  }

  function codeKey(type, code, func1, func2) {
    switch (type) {
      // case "keydown":
      //   func1();
      //   break;
      case "keyup":
        // func2(code);
        break;
      default:
        func1(code);
    }
  }
  function afafas(aaaa) {
    // bearlog.lug("___ afafas ___", aaaa);
    asdfokew(aaaa, playKey);
    // asdfokew(aaaa, playChord);
  }
  function sdfg(aaaa) {
    // asdfokew(aaaa, playKey);
    asdfokew(aaaa, playChord);
  }
  function asdflwe(aaaa) {
    // bassDictConst

    bearlog.lug("___ BASS NOTE ___", aaaa);

    asdfokew(aaaa, playKey);
  }

  function asdfokew({ keyCode, type }, fnca) {
    bearlog.lug("--KeyGO--", { keyCode, type });

    codeKey(type, keyCode, fnca);
  }

  // 1left 1right

  function acasd({ keyCode, type }) {
    bearlog.lug("___ ASDFASDA ___", keyCode, type);

    let asse = {
      37: -1,
      39: 1,
    }[keyCode];

    shiftpic(asse);
  }

  const okfdsd = (
    <>
      {/*  */}
      {/*  */}
    </>
  );

  return okfdsd;
}
